import React, { useEffect, useState } from 'react';
import Modal from 'modal-enhanced-react-native-web';
import { ActivityIndicator, FlatList, View } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { OrderProps } from '../../../store/types/mk_svc';
import { market_getOddsLabel } from '../helpers/markets';
import { order_calcAmericanOddsFromProbability, order_calcPotentialWinnings } from '../helpers/orders';


type OrderModificationModalProps = {
   isVisible:boolean,
   closeModal: () => void,
   onConfirm: () => void,
   order:OrderProps,
   modifying_property: 'probability',
   new_value: number | string
}


const OrderModificationModal = ({ isVisible, closeModal, order, onConfirm, modifying_property, new_value }:OrderModificationModalProps) => {
    
    const app_size:{ width:number } = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)

    if(!order){ return <></> }
    const cl = order.market_type === 'FOR_MONEY' ? '$' : 'E'
    return (
        <Modal propagateSwipe={true} isVisible={isVisible} deviceWidth={app_size.width} style={{ flex:1, margin:0, justifyContent: 'flex-end', alignItems:'center' }}
            animationIn='slideInUp' animationOut='slideOutDown' animationInTiming={500} onSwipeComplete={() => closeModal()} onBackdropPress={() => closeModal()}>
            <View style={{ ...localStyles.modalStyle, width:app_size.width }}>
                <View style={{ padding:10 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='bold' textAlign='center'>Review And Confirm Changes</Text>
                        <View style={{ flexDirection: 'row', alignItems:'center', marginTop:30, paddingLeft:20, paddingRight:20 }}>
                            <Text style={{flex:1/3}} size={16} weight='regular' color={Colors.brand.midnight}>Outcome</Text>
                            <Text style={{ flex:2/3 }} textAlign='right' size={16} color={Colors.brand.midnight} weight='semibold'>{order.title}</Text>
                        </View>
                        <View style={{ flexDirection: 'row', alignItems:'center', marginTop:8, paddingLeft:20, paddingRight:20 }}>
                            <Text style={{flex:1/2}} size={16} weight='regular' color={Colors.brand.midnight}>Unfulfilled Amount</Text>
                            <Text style={{ flex:1/2 }} textAlign='right' size={16} color={Colors.brand.midnight} weight='semibold'>{cl}{order.open_amt.toFixed(2)}</Text>
                        </View>
                        <View style={{ flexDirection: 'row', alignItems:'center', marginTop:4, paddingLeft:20, paddingRight:20 }}>
                            <Text style={{flex:1/2}} size={16} weight='regular' color={Colors.brand.midnight}>Updated Odds</Text>
                            <View style={{ flex:1/2, flexDirection:'row', alignItems:'center', justifyContent:'flex-end' }}>
                                <Text size={16} color={Colors.brand.midnight}>{market_getOddsLabel(order.odds)}</Text>
                                <Icon style={{ margin:5 }} name='arrow-right' type='feather' size={14} color={Colors.brand.midnight} />
                                <Text size={16} color={Colors.brand.midnight} weight='semibold'>{market_getOddsLabel(order_calcAmericanOddsFromProbability(new_value as number))}</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: 'row', alignItems:'center', marginTop:4, paddingLeft:20, paddingRight:20 }}>
                            <Text style={{flex:1/2}} size={16} weight='regular' color={Colors.brand.midnight}>Updated Winnings</Text>
                            <View style={{ flex:1/2, flexDirection:'row', alignItems:'center', justifyContent:'flex-end' }}>
                                <Text size={16} color={Colors.brand.midnight}>{cl}{order.potential_winnings.toFixed(2)}</Text>
                                <Icon style={{ margin:5 }} name='arrow-right' type='feather' size={14} color={Colors.brand.midnight} />
                                <Text size={16} color={Colors.brand.midnight} weight='semibold'>{cl}{order_calcPotentialWinnings(order_calcAmericanOddsFromProbability(new_value as number), order.open_amt).toFixed(2)}</Text>
                            </View>
                        </View>
                        
                        <View style={{ marginTop:20, flexDirection:'row', alignItems:'center' }}>
                            <TouchableOpacity native_id='order_update_cancel' style={{ flex:2/3, padding:10, borderWidth:1, borderColor:Colors.brand.midnight, borderRadius:4 }} onPress={() => closeModal()}>
                                <Text size={16} color={Colors.brand.midnight} weight='semibold' textAlign='center'>Cancel</Text>
                            </TouchableOpacity>
                            <TouchableOpacity native_id='order_update_confirm' style={{ flex:1/3, padding:10, backgroundColor:Colors.utility.success, borderWidth:1, borderColor:Colors.utility.success, borderRadius:4, marginLeft:5 }} onPress={() => onConfirm()}>
                                <Text size={16} color={Colors.shades.white} weight='semibold' textAlign='center'>Confirm</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
            </View>
        </Modal>
    )
}

const localStyles = {
    modalStyle: { backgroundColor: Colors.shades.white, borderTopRightRadius: 42, borderTopLeftRadius: 42, paddingBottom:35, paddingTop:20 },
}

const areEqual = (prevProps:OrderModificationModalProps, nextProps:OrderModificationModalProps) => {
    if(prevProps.isVisible !== nextProps.isVisible){ return false }
    return true
}



export default React.memo(OrderModificationModal, areEqual)